import { TransFunction, useTranslationsStore } from '@/translations/store';

export function useTranslation() {
    const store = useTranslationsStore();

    return { trans: store.getters.trans as TransFunction, currentLanguage: store.state.currentLanguage };
}

export default useTranslation;
